define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"dojo/when",
	"csi",
	"csi/config",
	"csi/_base/underscore",
	"csi/form/Widget",
	"csi/locale",
	"csi/reflection",
	"csi/store/_base",
	"csi/store/Names",
	"csi/store/Values",
	"csi/xml"
], function(declare,lang,Memory,when,csi,config,_,Widget,locale,reflection,csiStore,Names,ValuesStore,xml) {

	var QTY = "MerchProductQuantity";
	var DEFAULT_QTY = "DefaultQuantity";
	var CURRENT_QTY = "CurrentQuantity";
	var QTY_ATTR = "MerchProductQtyAttribute";
	var OPTION_QTY = "MerchOptionQuantity";
	var OPTION_TYPE = "MerchOptionType";

	return declare(Widget, {
		_storeQtyAttrs: null,

		getFieldStore: function(/*Field*/field, /*String*/value) {

			if (field.m_name == QTY_ATTR) {
				// summary: provide custom store for MerchProductQtyAttribute field
				return this._storeQtyAttrs;
			} else if (field.m_name == OPTION_TYPE) {
				var productSubtypeUrl = this.getFieldValue("Subtype");
				var optionSubtypeUrls = config.getSubtypeSetting(productSubtypeUrl, "ChildrenSubtypes");
				var activeOptionSubtypes = [csiStore.nameObject("")];
				_.each(optionSubtypeUrls, function(url) {
					if (config.getSubtypeSetting(url, "Active"))
						activeOptionSubtypes.push(csiStore.nameObject(reflection.getObject(url)));
				});
				return new Names({
					data: activeOptionSubtypes
				});
			}

			return this.inherited(arguments);

		},

		_getMerchCollection: function() {
			// summary: return node for MerchCollection
			var	ctx = this.getSourceContext();
			if (!ctx)
			    return null;

			return ctx.getNode() || ctx.getParent();
		},

		_getMerchCollectionDown: function() {
			// summary: return node for MerchCollectionDown
			var	ctx = this.getSourceContext();
			if (!ctx)
			    return null;

			var node = this._getMerchCollection();
			return node ? ctx.cache.getNode(node.Down) : null;
		},

		_onChangeQtyAttribute: function(/*View*/defView, /*Field*/field, /*Any*/value) {
			// summary: set Quantity field to value of attribute
			var	n = parseInt(this._getMerchCollectionDown()[value]);
			if (n) {
				this.setFieldValue(DEFAULT_QTY, n);
				this.setFieldValue(QTY, Math.max(n - this.getFieldValue(CURRENT_QTY), 1));
			}
		},

		onValidateProductQty : function(/*def.View*/defView, /*Field*/field, /*Any*/value, /*Object*/params) {
			// summary: validate quantities making sure they are between 1 and 100
			var qty = Number(value);
			if (isNaN(qty) || qty < 1 || qty > 100)
				throw new Error(locale.resource("InvalidQuantity", [locale.resource("MerchProductQuantity"), "1" , "100"]));
		},

		onValidateOptionQty : function(/*def.View*/defView, /*Field*/field, /*Any*/value, /*Object*/params) {
			// summary: validate quantities making sure they are between 0 and 50
			var qty = Number(value);
			if (isNaN(qty) || qty < 0 || qty > 50)
				throw new Error(locale.resource("InvalidQuantity", [locale.resource("MerchOptionQuantity"), "0" , "50"]));
		},

		/*
		 * @override
		 * Calculate and set current quantity and product quantity
		 */
		onViewStart: function(dfds) {
			this.inherited(arguments);

			var merchCollection = this._getMerchCollection();
			var self = this;
			if(merchCollection) {
				var store = new ValuesStore({
					typeNode: "MerchProductVersion",
					requestParameters: {
						"Qry.Limit.Path": xml.getUrlPath(merchCollection.$URL, xml.path("Children")),
						"Qry.Value.Attr": "Active"
					}
				});

				dfds.push(store.query().then(function(results) {
					var item = store.get(true);
					var curQty = item ? item[store.countProperty] : 0;
					self.addDefaultValue(CURRENT_QTY, curQty);
					if (self.getValueForField(self.getField("MerchProductQtyAttribute"))) {
						self.addDefaultValue(QTY, Math.abs(self.getValueForField(self.getField(DEFAULT_QTY)) - curQty));
					}
				}));
			}

		},

		_resolveView: function() {
			// summary: calculate store for MerchProductQtyAttribute; if values
			// are all zero, then don't show field
			var	fieldAttr = this.defView.getField(QTY_ATTR);
			var	down = this._getMerchCollectionDown();
			var rc = null, data = null;
			if (down) {
				rc = reflection.getClass(down.$Type);

				data = csi.transform(rc.getAttributes(), function(rca) {
					var	type = rca.getType();
					var	fmt = rca.getFormat() || "";
					var	bQty = xml.attributeTypeIsNumeric(type) &&
						(down[rca.getId()] >= 1) &&
						(fmt.indexOf("%") < 0) &&
						(fmt.indexOf("$") < 0);

					if (bQty) {
						return {id: rca.getId(), name: locale.typeId(down.$Type, rca.getId())};
					}

					return null;
				});
			}

			if (data) {
				// setup store for field
				data = csi.sort(data, "name");
				data.unshift({id: " ", name: ""});
				this._storeQtyAttrs = new Memory({data: data});

				// when field is changed, update quantity
				fieldAttr.m_onChange = "_onChangeQtyAttribute";
			} else {
				this.defView.removeField(QTY_ATTR);
				this.defView.removeField(DEFAULT_QTY);
			}

			this.inherited(arguments);

			// set default value for quantity to current value of attribute - this must be done after resolving fields
			var	qty = 0;

			if (data) {
				var	valueAttr = this.getValueForField(fieldAttr);
				qty = parseInt(down[valueAttr]) || 0;
			} else{
				this.addDefaultValue(QTY, 1);
			}

			this.addDefaultValue(DEFAULT_QTY, Math.max(qty, 1));
			this.addDefaultValue(OPTION_QTY, 0);

		}
	});
});